import CurrentPlanCard from "./CurrentPlanCard";
import { connect } from "react-redux";
import { RootState } from "store/store";
import {
  getCurrentSubscriptionPlanLicense
} from "shared/utility/ProductSubscriptionHelper";
import { Props as CurrentPlanCardProps } from "./CurrentPlanCard";
import ProductLicense from "interfaces/response/ProductLicense";
import { getPriceWithCurrencySymbol } from "shared/utility/CommonUtility";
import { checkIfIsEnterpriseLicense } from "shared/utility/ProductLicenseHelper";
import WidgetPanel from "components/common/WidgetPanel";
import NextPaymentDetails from "interfaces/response/NextPaymentDetails";
import SubscriptionPlanChooser from "./SubscriptionPlanChooser";
import { getFormattedNumber } from "shared/utility/NumberUtility";
import Subscription from "interfaces/response/Subscription";

interface Props {
  currentSubscription: Subscription | null;
  currentSubscriptionLicense?: ProductLicense | null;
  nextPaymentDetails: NextPaymentDetails;
}

export function SubscriptionPlan(props: Props) {
  const {
    currentSubscriptionLicense,
    currentSubscription,
    nextPaymentDetails,
  } = props;

  const getCurrentPlanPriceDisplayText = () => {
    if (currentSubscriptionLicense?.isDefaultFreeLocalLicense) {
      return "free";
    } else if (
      currentSubscriptionLicense &&
      checkIfIsEnterpriseLicense(currentSubscriptionLicense)
    ) {
      return "enterprise";
    }

    return currentSubscriptionLicense?.price === undefined
      ? "not defined"
      : getPriceWithCurrencySymbol(
          getFormattedNumber(currentSubscriptionLicense?.price ?? 0)
        );
  };

  const currentPlanDisplayConfig: CurrentPlanCardProps = {
    actionTag: currentSubscriptionLicense?.tag,
    numberOfAction: currentSubscription?.numberOfAllowedActions,
    price: getCurrentPlanPriceDisplayText(),
    billingInterval: currentSubscriptionLicense?.billingInterval!,
    nextPaymentDetails: nextPaymentDetails!,
  };

  return (
    <div className="flex flex-col lg:flex-row gap-x-5 gap-y-4 lg:gap-y-0">
      {currentSubscriptionLicense && (
        <div className="w-full lg:w-1/4">
          <WidgetPanel title="Current Plan">
            <CurrentPlanCard {...currentPlanDisplayConfig} />
          </WidgetPanel>
        </div>
      )}

      <div className={`w-full ${currentSubscriptionLicense ? "lg:w-3/4" : ""}`}>
        <SubscriptionPlanChooser
          nextPaymentDetails={currentPlanDisplayConfig.nextPaymentDetails}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    ...props,
    currentSubscriptionLicense: getCurrentSubscriptionPlanLicense(state),
  };
};

export default connect(mapStateToProps)(SubscriptionPlan);
